import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, FlexBox } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useCallback, useMemo } from 'react';
import { ListItemType, useScheduleContext, } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import { validateIntervals } from 'components/settings/components/sections/openingHours/views/schedule/utils/validate';
import { ListHeader } from '../listHeader/listHeader';
import { ListItem } from '../listItem/listItem';
import { ListItemContext } from '../listItem/listItem.context';
const headers = [
    {
        label: 'Standard business hours',
    },
    {
        label: 'Standard audio message',
        helpText: `Customers will hear this audio message when they call you outside of your standard business hours.
      This applies to all phone flows which use this schedule.`,
    },
    {
        label: 'Standard auto-reply (optional)',
        helpText: `If set, customers will receive this auto-reply when they email you outside your standard business hours.
      This applies to all email flows which use this schedule.`,
    },
];
export const BusinessHoursList = ({ audioMessage, autoReply, onAudioMessageChange, onAutoReplyChange, }) => {
    const { activeView: { menu: activeMenu }, intervalsErrors: { [ListItemType.Standard]: intervalsErrors }, listItems: { [ListItemType.Standard]: listItems }, setIntervalsErrors, setModifiedListItems, } = useScheduleContext();
    const handleValidateInterval = useCallback((dayIndex) => (intervals) => void setIntervalsErrors(ListItemType.Standard, validateIntervals({
        intervals,
        dayIndex,
        errors: intervalsErrors,
    })), [intervalsErrors, setIntervalsErrors]);
    const handleIntervalsChange = useCallback((id) => (intervals) => {
        const weekDay = listItems.find(({ id: weekDayId }) => weekDayId === id);
        if (!weekDay) {
            throw new Error('Weekday is not provided!');
        }
        setModifiedListItems(ListItemType.Standard, {
            [id]: Object.assign(Object.assign({}, weekDay), { intervals }),
        });
    }, [listItems, setModifiedListItems]);
    const context = useMemo(() => ({
        intervalsSelectProps: {
            errors: intervalsErrors,
            onChange: handleIntervalsChange,
            validate: handleValidateInterval,
        },
        onAudioMessageChange: (_) => onAudioMessageChange,
        onAutoReplyChange: (_) => onAutoReplyChange,
        onAutoReplyClear: (_) => onAutoReplyChange,
        onDelete: (_) => noop,
        onOverriddenChange: noop,
    }), [
        intervalsErrors,
        handleIntervalsChange,
        handleValidateInterval,
        onAudioMessageChange,
        onAutoReplyChange,
    ]);
    return (_jsxs(_Fragment, { children: [_jsx(ListHeader, { headers: headers }), _jsx(ListItemContext.Provider, Object.assign({ value: context }, { children: _jsx(Column.Row, Object.assign({ scrollable: true, noVerticalPadding: true }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "250", padding: "0 0 300" }, { children: listItems.map((listItem, index) => {
                            // If active view is not hours, we display only for one
                            // item from the list.
                            if (activeMenu !== 'hours' && index !== 0)
                                return;
                            return (_jsx(ListItem, { index: index, item: Object.assign(Object.assign({}, listItem), { announcement: audioMessage, auto_reply_template_id: autoReply }) }, listItem.id));
                        }) })) })) }))] }));
};
